import WorkIcon from '@material-ui/icons/Work';
export const ActiviteitIcon = WorkIcon;

